/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveApplicationProgressRequest
 */
export interface SaveApplicationProgressRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    maritalStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    coApplicantInfoGovermentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    coApplicantInfoMobile?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    coApplicantInfoEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    coApplicantInfoEmploymentType?: string;
    /**
     * 
     * @type {Date}
     * @memberof SaveApplicationProgressRequest
     */
    coApplicantInfoEmploymentYear?: Date;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    accomodationType?: string;
    /**
     * 
     * @type {Date}
     * @memberof SaveApplicationProgressRequest
     */
    habitationYear?: Date;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    govermentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    citizenship?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    ancestralHomeland?: string;
    /**
     * 
     * @type {Date}
     * @memberof SaveApplicationProgressRequest
     */
    inDenmarkSinceYear?: Date;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    residentPermit?: string;
    /**
     * 
     * @type {Date}
     * @memberof SaveApplicationProgressRequest
     */
    residentPermitValidDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    employmentType?: string;
    /**
     * 
     * @type {Date}
     * @memberof SaveApplicationProgressRequest
     */
    employmentYear?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SaveApplicationProgressRequest
     */
    dankort?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveApplicationProgressRequest
     */
    debitCardsMasterCard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveApplicationProgressRequest
     */
    creditCardsMasterCard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveApplicationProgressRequest
     */
    creditCardsVisa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveApplicationProgressRequest
     */
    creditCardsDinersClub?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveApplicationProgressRequest
     */
    creditCardsPetrol?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    childrenGroup1?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    childrenGroup2?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    childrenGroup3?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    childrenGroup4?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    shareOfExpenses?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    purposeOfLoan?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    purposeOfLoanOther?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    monthlyIncomeGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    monthlyIncomeNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    monthlyRentalCost?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    householdLivingExpenses?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    householdOtherLoanExpenses?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    financeOtherLoansBalanceOfLoans?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    financeOtherLoansMonthlyCostOfLoans?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    payoutClearingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    payoutAccountNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    coApplicantMonthlyIncomeGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveApplicationProgressRequest
     */
    coApplicantMonthlyIncomeNet?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveApplicationProgressRequest
     */
    applicationId?: string;
}

/**
 * Check if a given object implements the SaveApplicationProgressRequest interface.
 */
export function instanceOfSaveApplicationProgressRequest(value: object): value is SaveApplicationProgressRequest {
    return true;
}

export function SaveApplicationProgressRequestFromJSON(json: any): SaveApplicationProgressRequest {
    return SaveApplicationProgressRequestFromJSONTyped(json, false);
}

export function SaveApplicationProgressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveApplicationProgressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'maritalStatus': json['maritalStatus'] == null ? undefined : json['maritalStatus'],
        'coApplicantInfoGovermentId': json['coApplicantInfoGovermentId'] == null ? undefined : json['coApplicantInfoGovermentId'],
        'coApplicantInfoMobile': json['coApplicantInfoMobile'] == null ? undefined : json['coApplicantInfoMobile'],
        'coApplicantInfoEmail': json['coApplicantInfoEmail'] == null ? undefined : json['coApplicantInfoEmail'],
        'coApplicantInfoEmploymentType': json['coApplicantInfoEmploymentType'] == null ? undefined : json['coApplicantInfoEmploymentType'],
        'coApplicantInfoEmploymentYear': json['coApplicantInfoEmploymentYear'] == null ? undefined : (new Date(json['coApplicantInfoEmploymentYear'])),
        'accomodationType': json['accomodationType'] == null ? undefined : json['accomodationType'],
        'habitationYear': json['habitationYear'] == null ? undefined : (new Date(json['habitationYear'])),
        'govermentId': json['govermentId'] == null ? undefined : json['govermentId'],
        'citizenship': json['citizenship'] == null ? undefined : json['citizenship'],
        'ancestralHomeland': json['ancestralHomeland'] == null ? undefined : json['ancestralHomeland'],
        'inDenmarkSinceYear': json['inDenmarkSinceYear'] == null ? undefined : (new Date(json['inDenmarkSinceYear'])),
        'residentPermit': json['residentPermit'] == null ? undefined : json['residentPermit'],
        'residentPermitValidDate': json['residentPermitValidDate'] == null ? undefined : (new Date(json['residentPermitValidDate'])),
        'employmentType': json['employmentType'] == null ? undefined : json['employmentType'],
        'employmentYear': json['employmentYear'] == null ? undefined : (new Date(json['employmentYear'])),
        'dankort': json['dankort'] == null ? undefined : json['dankort'],
        'debitCardsMasterCard': json['debitCardsMasterCard'] == null ? undefined : json['debitCardsMasterCard'],
        'creditCardsMasterCard': json['creditCardsMasterCard'] == null ? undefined : json['creditCardsMasterCard'],
        'creditCardsVisa': json['creditCardsVisa'] == null ? undefined : json['creditCardsVisa'],
        'creditCardsDinersClub': json['creditCardsDinersClub'] == null ? undefined : json['creditCardsDinersClub'],
        'creditCardsPetrol': json['creditCardsPetrol'] == null ? undefined : json['creditCardsPetrol'],
        'childrenGroup1': json['childrenGroup1'] == null ? undefined : json['childrenGroup1'],
        'childrenGroup2': json['childrenGroup2'] == null ? undefined : json['childrenGroup2'],
        'childrenGroup3': json['childrenGroup3'] == null ? undefined : json['childrenGroup3'],
        'childrenGroup4': json['childrenGroup4'] == null ? undefined : json['childrenGroup4'],
        'shareOfExpenses': json['shareOfExpenses'] == null ? undefined : json['shareOfExpenses'],
        'purposeOfLoan': json['purposeOfLoan'] == null ? undefined : json['purposeOfLoan'],
        'purposeOfLoanOther': json['purposeOfLoanOther'] == null ? undefined : json['purposeOfLoanOther'],
        'monthlyIncomeGross': json['monthlyIncomeGross'] == null ? undefined : json['monthlyIncomeGross'],
        'monthlyIncomeNet': json['monthlyIncomeNet'] == null ? undefined : json['monthlyIncomeNet'],
        'monthlyRentalCost': json['monthlyRentalCost'] == null ? undefined : json['monthlyRentalCost'],
        'householdLivingExpenses': json['householdLivingExpenses'] == null ? undefined : json['householdLivingExpenses'],
        'householdOtherLoanExpenses': json['householdOtherLoanExpenses'] == null ? undefined : json['householdOtherLoanExpenses'],
        'financeOtherLoansBalanceOfLoans': json['financeOtherLoansBalanceOfLoans'] == null ? undefined : json['financeOtherLoansBalanceOfLoans'],
        'financeOtherLoansMonthlyCostOfLoans': json['financeOtherLoansMonthlyCostOfLoans'] == null ? undefined : json['financeOtherLoansMonthlyCostOfLoans'],
        'payoutClearingNumber': json['payoutClearingNumber'] == null ? undefined : json['payoutClearingNumber'],
        'payoutAccountNumber': json['payoutAccountNumber'] == null ? undefined : json['payoutAccountNumber'],
        'coApplicantMonthlyIncomeGross': json['coApplicantMonthlyIncomeGross'] == null ? undefined : json['coApplicantMonthlyIncomeGross'],
        'coApplicantMonthlyIncomeNet': json['coApplicantMonthlyIncomeNet'] == null ? undefined : json['coApplicantMonthlyIncomeNet'],
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
    };
}

export function SaveApplicationProgressRequestToJSON(json: any): SaveApplicationProgressRequest {
    return SaveApplicationProgressRequestToJSONTyped(json, false);
}

export function SaveApplicationProgressRequestToJSONTyped(value?: SaveApplicationProgressRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maritalStatus': value['maritalStatus'],
        'coApplicantInfoGovermentId': value['coApplicantInfoGovermentId'],
        'coApplicantInfoMobile': value['coApplicantInfoMobile'],
        'coApplicantInfoEmail': value['coApplicantInfoEmail'],
        'coApplicantInfoEmploymentType': value['coApplicantInfoEmploymentType'],
        'coApplicantInfoEmploymentYear': value['coApplicantInfoEmploymentYear'] == null ? undefined : ((value['coApplicantInfoEmploymentYear']).toISOString()),
        'accomodationType': value['accomodationType'],
        'habitationYear': value['habitationYear'] == null ? undefined : ((value['habitationYear']).toISOString()),
        'govermentId': value['govermentId'],
        'citizenship': value['citizenship'],
        'ancestralHomeland': value['ancestralHomeland'],
        'inDenmarkSinceYear': value['inDenmarkSinceYear'] == null ? undefined : ((value['inDenmarkSinceYear']).toISOString()),
        'residentPermit': value['residentPermit'],
        'residentPermitValidDate': value['residentPermitValidDate'] == null ? undefined : ((value['residentPermitValidDate']).toISOString()),
        'employmentType': value['employmentType'],
        'employmentYear': value['employmentYear'] == null ? undefined : ((value['employmentYear']).toISOString()),
        'dankort': value['dankort'],
        'debitCardsMasterCard': value['debitCardsMasterCard'],
        'creditCardsMasterCard': value['creditCardsMasterCard'],
        'creditCardsVisa': value['creditCardsVisa'],
        'creditCardsDinersClub': value['creditCardsDinersClub'],
        'creditCardsPetrol': value['creditCardsPetrol'],
        'childrenGroup1': value['childrenGroup1'],
        'childrenGroup2': value['childrenGroup2'],
        'childrenGroup3': value['childrenGroup3'],
        'childrenGroup4': value['childrenGroup4'],
        'shareOfExpenses': value['shareOfExpenses'],
        'purposeOfLoan': value['purposeOfLoan'],
        'purposeOfLoanOther': value['purposeOfLoanOther'],
        'monthlyIncomeGross': value['monthlyIncomeGross'],
        'monthlyIncomeNet': value['monthlyIncomeNet'],
        'monthlyRentalCost': value['monthlyRentalCost'],
        'householdLivingExpenses': value['householdLivingExpenses'],
        'householdOtherLoanExpenses': value['householdOtherLoanExpenses'],
        'financeOtherLoansBalanceOfLoans': value['financeOtherLoansBalanceOfLoans'],
        'financeOtherLoansMonthlyCostOfLoans': value['financeOtherLoansMonthlyCostOfLoans'],
        'payoutClearingNumber': value['payoutClearingNumber'],
        'payoutAccountNumber': value['payoutAccountNumber'],
        'coApplicantMonthlyIncomeGross': value['coApplicantMonthlyIncomeGross'],
        'coApplicantMonthlyIncomeNet': value['coApplicantMonthlyIncomeNet'],
        'applicationId': value['applicationId'],
    };
}

